import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Registration} from "../../models/registration";

@Directive()
@Injectable()
export class DeterminantService {

  public registration: Registration;
  public serviceId: string;
  public type: string;
  public jsonString: string;
  public selectedIndex: number;

  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public updateDeterminant: EventEmitter<any> = new EventEmitter();

  @Output() public changeCost: EventEmitter<any> = new EventEmitter();
  @Output() public updateCostDeterminant: EventEmitter<any> = new EventEmitter();

  public initData() {
    console.log("Determinant Service Initialized");
    this.change.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      type: this.type,
      jsonString: this.jsonString,
    });
  }

  public initCostData() {
    this.changeCost.emit({
      jsonString: this.jsonString,
      selectedIndex: this.selectedIndex,
    });
  }

  public initDeterminant() {
    this.updateDeterminant.emit({
      registration: this.registration,
    });
  }

  public initCostDeterminant() {
    this.updateCostDeterminant.emit({
      jsonString: this.jsonString,
      selectedIndex: this.selectedIndex,
    });
  }

}
